var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableFooter from '@material-ui/core/TableFooter';
import get from 'lodash/get';
import { getSorting, stableSort } from 'ezyvet-fe-helpers';
import TablePagination from './TablePagination';
import TableCell from './TableCell';
import TableHeader from './TableHeader';
// style for the table, header row, row and selected row for now
var useTableStyles = makeStyles({
    table: function (props) { return (__assign({}, props.table)); },
    header: function (props) { return (__assign({}, props.header)); },
    row: function (props) { return (__assign({ borderRadius: '3px', backgroundColor: '#FCFCFC', boxShadow: '2px 2px 4px 0 rgba(0,0,0,0.08)' }, props.row)); },
});
/**
 * @deprecated
 * Use `Table` to render a paginated/sortable list of records
 */
export default function Table(props) {
    var columns = props.columns, records = props.records, _a = props.style, style = _a === void 0 ? {} : _a, _b = props.size, size = _b === void 0 ? 'medium' : _b, _c = props.paginationOptions, paginationOptions = _c === void 0 ? {
        rowsPerPageOptions: [5, 10, 25],
        page: 0,
        rowsPerPage: 5,
    } : _c, _d = props.pageable, pageable = _d === void 0 ? false : _d, sortable = props.sortable, _e = props.sortByDefault, sortByDefault = _e === void 0 ? {
        dir: 'asc',
    } : _e;
    var classes = useTableStyles(style);
    var _f = useState(paginationOptions.page), page = _f[0], setPage = _f[1];
    var _g = useState(paginationOptions.rowsPerPage), rowsPerPage = _g[0], setRowsPerPage = _g[1];
    var _h = React.useState(sortByDefault.dir), order = _h[0], setOrder = _h[1];
    var _j = React.useState(sortByDefault && sortByDefault.field), orderBy = _j[0], setOrderBy = _j[1];
    var handleChangePage = function (newPage) {
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (value) {
        setRowsPerPage(parseInt(value, 10));
        setPage(0);
    };
    var handleRequestSort = function (property) {
        var isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    // always sort the rows and paginate if needed
    var theRowsToRender = stableSort(records, getSorting(order, orderBy));
    theRowsToRender =
        rowsPerPage > 0
            ? theRowsToRender.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : theRowsToRender;
    var renderCell = function (column, row) {
        var ColumnRender = column.renderBody;
        var value = get(row, column.name);
        var content = ColumnRender ? React.createElement(ColumnRender, { value: value, record: row }) : value;
        return (React.createElement(TableCell, { key: column.name, align: column.align, style: column.style }, content));
    };
    return (React.createElement(MuiTableContainer, null,
        React.createElement(MuiTable, { className: classes.table, size: size },
            React.createElement(TableHeader, { classes: classes.header, columns: columns, order: order, orderBy: orderBy, sortable: sortable, onRequestSort: handleRequestSort }),
            React.createElement(MuiTableBody, null, theRowsToRender.map(function (row, index) { return (React.createElement(React.Fragment, { key: row.id || index },
                React.createElement(MuiTableRow, { className: classes.row }, columns.map(function (column) { return renderCell(column, row); })),
                React.createElement("tr", { style: { height: '10px' } }))); })),
            React.createElement(MuiTableFooter, null, pageable ? (React.createElement(TablePagination, { colSpan: columns.length, handleChangePage: handleChangePage, handleChangeRowsPerPage: handleChangeRowsPerPage, rowsCount: records.length, rowsPerPageOptions: paginationOptions.rowsPerPageOptions, rowsPerPage: rowsPerPage, page: page })) : null))));
}
//# sourceMappingURL=Table.js.map